<template>
  <o-section :level="level+1" :title="label || schema.verbose_name" body-classes="p-0" not-closable>
    <o-item-editable-table v-model="items"
                           :default-new-value="newChild"
                           :item-name="schema.verbose_name"
                           @change="changed">
      <template slot="o-headers">
        <th v-if="canSee(schema, 'product')">{{ schema.fields.product.label }}</th>
        <th v-if="canSee(schema, 'capacity')">{{ schema.fields.capacity.label }}</th>
      </template>
      <template slot="o-body"
                slot-scope="{ item, index }">
        <td v-if="canSee(schema, 'product')">
          <o-widget-wrapper :form-state="formState" :schema="schema" :server-errors="_se"
                            :server-errors-index="index" :validators="validators.$each[index]" name="product">
            <o-select
              v-model="items[index].product"
              :form-state="formState"
              :items="optionCodeProductItems"
              :loading="optionCodeProductWorking"
              :server-errors="_se"

              :server-errors-index="index"
              :validators="validators.$each[index]"
              add-title="Create New" allow-add name="product"
              nolabel sort-field="code" store-name="CodeProduct"

              text-field="code"
              v-bind="schema.fields.product"
              value-field="id"
            >
              <template slot="form" slot-scope="{item, formState, serverErrors}">
                <code-product-form :form-state="formState" :item="item" :server-errors="serverErrors"
                                   in-modal></code-product-form>
              </template>
            </o-select>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'capacity')">
          <o-widget-wrapper :form-state="formState" :schema="schema" :server-errors="_se"
                            :server-errors-index="index" :validators="validators.$each[index]" name="capacity">
            <o-text-field
              v-model="items[index].capacity"

              :form-state="formState"
              :server-errors="_se" :server-errors-index="index" :validators="validators.$each[index]"
              name="capacity" nolabel v-bind="schema.fields.capacity"
            ></o-text-field>
          </o-widget-wrapper>
        </td>
      </template>
    </o-item-editable-table>
  </o-section>
</template>
<script>
import schema from "../../schema/index";
import {cleanUpModel} from "../../../vue-ocom/schema/schema_vuetify";
import {CreateDefaultItem} from "../../../vue-ocom/schema/schema_utils";
import {CreateCodeTableFetchMixin, CreateFormStateMixin, CreateGroupPermissionMixin} from '../../../vue-ocom/mixins'
import OItemEditableTable from "../../../vue-ocom/components/table/OItemEditableTable";
import OSection from "../../../vue-ocom/components/layout/OSection";


export default {
  name: 'TruckSizeFormTable',
  mixins: [CreateFormStateMixin('validators'),
    CreateGroupPermissionMixin('TruckSize'),
    CreateCodeTableFetchMixin(['CodeProduct',])
  ],
  components: {OItemEditableTable, OSection,},
  model: {
    prop: "items",
    event: "changed"
  },
  props: {
    items: {
      type: Array, default: () => {
      }
    },
    label: {type: String, default: null},
    validators: {type: Object, default: () => null},
    level: {type: Number, default: 0},
  },
  data: function () {
    return {
      schemaModel: cleanUpModel(schema.TruckSize, {}), /*Use this.schema instead */
      newChild: CreateDefaultItem(schema.TruckSize)
    };
  },
  methods: {
    changed() {
      if (this.validator) {
        this.validator.$touch();
      }

      if (this.formState)
        this.formState.dirty = true;

      this.$emit('changed', this.items);
    }
  },
  computed: {},
  created() {
    // this.loadCodeTables()
  }
}
</script>
